import { Table } from "antd";
import React, { forwardRef, useEffect, useMemo, useState } from "react";
import commonFn from "@/utils/commonFn";

const CustomTable = forwardRef((props, ref) => {
  const {
    tableLoading,
    columns,
    tableList,
    rowSelection,
    rowClassName = (() => ['table-row-gradient']),
    pagination,
    bordered = false,
    rowKey,
    refreshKey,
    handleTableChange,
    setTableHead,
    getTableListFn,
    expandable,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
    tableScroll,
    tableScrollX,
    tableScrollYAll,
    tableScrollY,
    tableCss,
    summary,
    size = "middle",
  } = props;

  const [filterValues, setFilterValues] = useState({});

  useEffect(() => {
    setFilterValues({});
  }, [refreshKey]);

  const tableColumns = useMemo(
    () => commonFn.handleColunmFn(
      (columns || []).map((column) => {
        if (!column.titleType || typeof column.onChange !== "function") {
          return column;
        }

        return {
          ...column,
          filterValue: filterValues[column.dataIndex],
          onChange: (event) => {
            if (event && typeof event === "object") {
              event.tablePageSize = pagination?.pageSize;
            }
            const value = column.titleType === "Input"
              ? event?.target?.value
              : event;
            setFilterValues((prev) => ({
              ...prev,
              [column.dataIndex]: value,
            }));
            commonFn.setActiveTablePageSize(pagination?.pageSize);
            try {
              column.onChange(event);
            } finally {
              commonFn.setActiveTablePageSize();
            }
          },
        };
      })
    ).filter((col) => !col.hidden) || [],
    [columns, filterValues, pagination?.pageSize]
  );

  const paginationConfig = {
    showQuickJumper: true,
    current: pagination?.current,
    pageSize: pagination?.pageSize,
    total: pagination?.total,
    showSizeChanger: true,
    showTotal: (total) => {
      return `Total: ${total} items`;
    },
    pageSizeOptions: [10, 20, 25, 50, 100,500,1000],
  };

  const onChange = (pagination, filters, sorter) => {
    const { field: orderField, order: orderType } = sorter
    setTableHead(pre => {
      const tableHeadTemp = {
        ...pre,
        orderField,
        orderType,
      }
      getTableListFn(pagination.current, pagination.pageSize, tableHeadTemp);
      return tableHeadTemp
    })
  }

  return (
    <Table
      size={size}
      summary={summary} 
      loading={tableLoading}
      columns={tableColumns}
      dataSource={tableList}
      pagination={pagination ? paginationConfig : false}
      bordered={bordered}
      rowSelection={rowSelection}
      rowClassName={rowClassName}
      rowKey={rowKey || "id"}
      key={refreshKey}
      onChange={handleTableChange || onChange}
      expandable={expandable}
      scroll={
        tableScroll || {
          x: tableScrollX || "max-content",
          ...(tableList?.length && {
            y: tableScrollYAll || `calc(100vh - ${tableScrollY || '280px'})`,
          }),
      }}
      className={tableCss || "mainTable"}
    />
  );
});
export default CustomTable;
